/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Team = {

	deleteTeam (context, teamId, onSuccess, onError, options) {
		Api.delete(context,
			"/team/team"
			+ "?teamId=" + teamId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, teamId, onSuccess, onError, options) {
		Api.get(context,
			"/team"
			+ "?teamId=" + teamId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestTeamsWithProjects (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/team/contest-teams-with-projects"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTeams (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/team/teams"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTeam (context, contestId, name, onSuccess, onError, options) {
		Api.post(context,
			"/team/team"
			+ "?contestId=" + contestId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAssignProject (context, projectId, teamId, onSuccess, onError, options) {
		Api.put(context,
			"/team/assign-project"
			+ "?projectId=" + projectId
			+ "&teamId=" + teamId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putTeam (context, contestId, teamId, newName, onSuccess, onError, options) {
		Api.put(context,
			"/team/team"
			+ "?contestId=" + contestId
			+ "&teamId=" + teamId
			+ "&newName=" + newName
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
